import React from "react";
import { __ } from '@wordpress/i18n';
import PreviousStepLink from '../../../../components/util/previous-step-link/index';

const CongratulationsActions = (props) => {
	const { onPreviousClick, customizeStep } = props;

	return (
		<>
			<PreviousStepLink customizeStep={customizeStep} onClick={onPreviousClick} before>{__('Back', 'astra-sites')}</PreviousStepLink>
		</>
	);
};

export default CongratulationsActions;
